import { render, staticRenderFns } from "./Patient_count.vue?vue&type=template&id=08035e58&scoped=true"
import script from "./Patient_count.vue?vue&type=script&lang=js"
export * from "./Patient_count.vue?vue&type=script&lang=js"
import style0 from "./Patient_count.vue?vue&type=style&index=0&id=08035e58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08035e58",
  null
  
)

export default component.exports